import React from "react";
import {
  WSElement,
  WSElementColorsType,
  WSForm,
  WSTextInput,
  WSText
} from "@wingspanhq/fe-component-library";
import { LABEL_COLOR, ListElement, ListLabel, LIST_MT } from "./LabelValueList";

export type ComponentProps = Omit<
  React.ComponentPropsWithRef<typeof WSTextInput>,
  "name" | "value" | "onChange" | "error"
>;

type FormFieldProps = {
  name: string;
  label: ListLabel;
  labelColor?: WSElementColorsType;
  componentProps?: ComponentProps;
};

export const FormField = ({
  name,
  label,
  labelColor = LABEL_COLOR,
  componentProps
}: FormFieldProps) => (
  <>
    <ListElement color={labelColor} value={label} />
    <WSForm.Field
      name={name}
      component={WSTextInput}
      componentProps={componentProps}
    />
  </>
);

export type RowDataEditable = { id: string } & FormFieldProps;

interface FormFieldListProps {
  items?: RowDataEditable[] | null;
  labelColor?: WSElementColorsType;
}

const FormFieldList: React.FC<FormFieldListProps> = ({
  items,
  labelColor = LABEL_COLOR
}) => {
  if (!Array.isArray(items))
    return <WSText color={LABEL_COLOR}>No items defined</WSText>;

  return (
    <>
      {items.map(({ id, label, name, componentProps }) => {
        return (
          <WSElement key={id} mt={LIST_MT}>
            <FormField
              name={name}
              label={label}
              labelColor={labelColor}
              componentProps={componentProps}
            />
          </WSElement>
        );
      })}
    </>
  );
};

export default FormFieldList;
